import React from 'react';
import './TelegramSelect.css';

const TelegramSelect = (props) => {
    return (
        <select {...props} className={'telegramSelect ' + props.className}>
            { props.elements.map((element, index) => <option key={element.id}>{element.value}</option>) }
        </select>
    );
};

export default TelegramSelect;
